import React from 'react';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import DownloadCloudIcon from 'icons/DownloadCloud.icon';
import PdfImage from 'assets/images/pdf.webp';
import { NEW_WINDOW_PROPS } from 'data/global';

import './SecureDownloadBadge.styles.scss';

const ADOBE_LINK = 'https://get.adobe.com/uk/reader/';

const SecureDownloadBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a
      className="secure-download-badge"
      href={ADOBE_LINK}
      {...NEW_WINDOW_PROPS}
    >
      <ResolveImage src={PdfImage} />

      <div>
        <p>{t('secureDownloads')}</p>
        <p>
          {t('secureDownloadsDescription')} <DownloadCloudIcon />
        </p>
      </div>
    </a>
  );
};

export default SecureDownloadBadge;
